enum JobLogStatus {
  Started,
  Succeeded,
  PartiallySucceeded,
  Failed,
}

export default JobLogStatus
